import { render, staticRenderFns } from "./DefaultContent.vue?vue&type=template&id=c97838cc&"
import script from "./DefaultContent.vue?vue&type=script&lang=js&"
export * from "./DefaultContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports